import React from "react";
import { string, object, bool } from "prop-types";

import Icon from "../../Icon/Icon.jsx";
import ImageElement from "../../ImageElement/ImageElement.jsx";

const propTypes = {
  title: string.isRequired,
  srcset: string,
  sizes: string,
  date: string,
  description: string,
  cta: string,
  ctaIcon: string,
  url: string,
  showCta: bool,
  focusRef: object,
};

/**
 * A single promo card for the Promo Listing results. Intentionally reproduces the exact
 * markup and CSS classes of the existing Promo component (components/MultiPromo/Promo.jsx)
 * so it is visually identical to the existing Multi Promo cards, and adds the optional
 * `promo__date` (styled by the existing promo.scss) above the title per US 423684.
 *
 * The existing Promo component is not imported/modified — this is a new component that
 * reuses the same shared styles.
 */
const PromoResultCard = (props) => {
  const {
    title,
    srcset,
    sizes,
    date,
    description,
    cta,
    ctaIcon,
    url,
    showCta,
    focusRef,
  } = props;

  const id = `promo-card-${Math.floor(Math.random() * 100000)}`;

  // The shared makeClickable.js binds .js-make-clickable elements only once on page load,
  // but these cards render asynchronously (after the API call), so that binding misses them.
  // Handle navigation in React instead so the image/title are clickable like the CTA.
  const goToUrl = () => {
    if (url) {
      window.location.href = url;
    }
  };

  return (
    <section className="promo">
      <figure className="promo__media">
        <div
          className="promo__picture js-make-clickable"
          data-location={url}
          onClick={goToUrl}
        >
          <ImageElement
            className="promo__img"
            srcSet={srcset}
            sizes={sizes || "(min-width: 910px) 50vw, 100vw"}
            loading="lazy"
          />
        </div>
      </figure>
      <div className="promo__content">
        {date && <p className="promo__date">{date}</p>}
        <div
          className="promo__title subheader1 js-make-clickable"
          id={id}
          data-location={url}
          onClick={goToUrl}
          role="link"
          tabIndex={0}
          ref={focusRef}
          onKeyDown={(e) => {
            if (e.key === "Enter") goToUrl();
          }}
        >
          {title}
        </div>
        {description && <p className="promo__summary">{description}</p>}
        {showCta && cta && (
          <a href={url} aria-labelledby={id} className="promo__cta">
            {cta}
            {ctaIcon && <Icon iconName={ctaIcon} />}
          </a>
        )}
      </div>
    </section>
  );
};

PromoResultCard.propTypes = propTypes;
export default PromoResultCard;
